module.exports = __webpack_public_path__ + "components/weather-icon/static/dayheavyrain-b7a049c871a03c6f18de8315a7c697a6.svg";